//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: 'ActivityNudge',
    props: {
        heading: {
            type: String,
            default: 'Check your Performance!'
        },
        subHeading: {
            type: String,
            default: 'Take performance analysis test and analyze your strength and weakness'
        },
        ctaText: {
            type: String,
            default: 'Take a PAT'
        },
        ctaFunction: {
            type: Function,
            default: () => {}
        }
    },
    methods: {
        async ctaClickHandler() {
            await this.ctaFunction();
        }
    }
};
